import { render, staticRenderFns } from "./editTopic.vue?vue&type=template&id=767adb60&"
import script from "./editTopic.vue?vue&type=script&lang=js&"
export * from "./editTopic.vue?vue&type=script&lang=js&"
import style0 from "./editTopic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports